import { useLocation, useNavigate } from "react-router-dom";
import CheckoutPaymentStripe from "./CheckoutPayment_STRIPE";
import CheckoutPaymentPaggo from "./CheckoutPayment_PAGGO";
import "./CheckoutPayment.css";

function isStripeCodigo(codigo) {
  return String(codigo || "").toUpperCase().includes("STRIPE");
}

function isPaggoCodigo(codigo) {
  return String(codigo || "").toUpperCase().includes("PAGGO");
}

export default function CheckoutPayment() {
  const navigate = useNavigate();
  const location = useLocation();

  const paymentData = location.state?.checkoutConfirmacion || null;
  const codigo = String(paymentData?.pasarela_codigo || "").toUpperCase();

  if (!paymentData) {
    return (
      <div className="nb-checkout-payment-scope">
        <div className="nb-checkout-payment">
          <div className="nb-payment-shell">
            <div className="nb-payment-panel nb-payment-panel--error">
              <div className="nb-payment-icon nb-payment-icon--error">!</div>
              <h2>Pago no disponible</h2>
              <p>No se recibió información del pago.</p>
              <div className="nb-payment-actions">
                <button
                  type="button"
                  className="nb-btn nb-btn--primary"
                  onClick={() => navigate("/store/cart")}
                >
                  Volver al carrito
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isPaggoCodigo(codigo)) {
    return (
      <div className="nb-checkout-payment-scope">
        <div className="nb-checkout-payment">
          <CheckoutPaymentPaggo initialData={paymentData} />
        </div>
      </div>
    );
  }

  if (isStripeCodigo(codigo)) {
    return (
      <div className="nb-checkout-payment-scope">
        <div className="nb-checkout-payment">
          <CheckoutPaymentStripe initialData={paymentData} />
        </div>
      </div>
    );
  }

  return (
    <div className="nb-checkout-payment-scope">
      <div className="nb-checkout-payment">
        <div className="nb-payment-shell">
          <div className="nb-payment-panel nb-payment-panel--error">
            <div className="nb-payment-icon nb-payment-icon--error">!</div>
            <h2>Pasarela no soportada</h2>
            <p>{codigo || "No se pudo identificar la pasarela."}</p>
            <div className="nb-payment-actions">
              <button
                type="button"
                className="nb-btn nb-btn--primary"
                onClick={() => navigate("/store/cart")}
              >
                Volver al carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}